import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Dropdown from 'react-dropdown';
import {TextArea} from '@react-ui-org/react-ui';
import {ModalPerido} from '../RegistroEmpresas/ModalPerido';
import {sumarMinuto} from '../../fuctions/Sumar_Minutos_Horas';
import {sumarUnaHora} from '../../fuctions/Sumar_Minutos_Horas';
import Switch from 'react-switch';
import {Checkbox} from '@mui/material';

export const CatServAñadir = (props) => {
	const {sedes} = props;
	const [sedeSeleccionada, setsedeSeleccionada] = useState({});
	const [ServiciosPosibles, setServiciosPosibles] = useState([]);

	const [modalAnadirSede, setModalAnadirSede] = useState(false);
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [ModalErrorCargarCategorias, setModalErrorCargarCategorias] = useState(false);
	const [ModalErrorCargarServicios, setModalErrorCargarServicios] = useState(false);
	const [ModalErrorConsulta, setModalErrorConsulta] = useState(false);
	const [ModalPeriodo, setModalPeriodo] = useState(false);
	const [ModalServicioNoCompleto, setModalServicioNoCompleto] = useState(false);
	const [ModalServicioOk, setModalServicioOk] = useState(false);
	const [ServicioPersonalizado, setServicioPersonalizado] = useState(false);

	const [ErroresFormulario, setErroresFormulario] = useState([])

	const superCat = [
		{
			id: 1,
			nombre: 'Servicio Sanitario',
		},
		{
			id: 2,
			nombre: 'Servicio Socio Sanitario',
		},
		{
			id: 3,
			nombre: 'Otro',
		},
	];
	const [ListaCategorias, setListaCategorias] = useState([]);
	const [SuperCateSeleccionada, setSuperCateSeleccionada] = useState({});
	const [ListaCategoriasFiltrada, setListaCategoriasFiltrada] = useState([]);
	const [CategoriaSelecionada, setCategoriaSelecionada] = useState({});
	const [ListaServicios, setListaServicios] = useState([]);

	const [ServicioSeleccionado, setServicioSeleccionado] = useState({
		categoria_id: 0,
		nombre: '',
		nombrePersonalizado: '',
		estado: 'pendiente',
		horasMin: 0,
		shareCare: false,
		domicilio: false,
		sedes: [],
		horario: [
			{
				nombre: 'lunes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'martes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'miercoles',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'jueves',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'viernes',
				estado: true,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'sabado',
				estado: false,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '16:00',
						solapamiento: false,
					},
				],
			},
			{
				nombre: 'domingo',
				estado: false,
				periodos: [
					{
						id: 1,
						hora_inicio: '08:00',
						hora_fin: '20:00',
						solapamiento: false,
					},
				],
			},
		],
	});
	useEffect(() => {
		// Verifica si el precio mínimo de ServicioSeleccionado es menor que 0.
		if (ServicioSeleccionado.precioMin < 0) {
			// Actualiza el estado de ServicioSeleccionado estableciendo el precio mínimo como 0.0 (convertido a tipo float).
			setServicioSeleccionado({...ServicioSeleccionado, precioMin: parseFloat(0.0)});
		}

		// Verifica si el precio mínimo de ServicioSeleccionado es mayor que 999.
		if (ServicioSeleccionado.precioMin > 999) {
			// Actualiza el estado de ServicioSeleccionado estableciendo el precio mínimo como 999.0 (convertido a tipo float).
			setServicioSeleccionado({...ServicioSeleccionado, precioMin: parseFloat(999.0)});
		}
	}, [ServicioSeleccionado]);

	/**
	 * Obtiene las categorías y actualiza el estado de ListaCategorias.
	 */
	const getCategorias = () => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		})
			.then((response) => {
				// Actualiza el estado de ListaCategorias con los datos de las categorías obtenidas.
				setListaCategorias([...response.data]);
			})
			.catch((error) => {
				console.error(error);
				setModalErrorCargarCategorias(true);
			});
	};

	/**
	 * Obtiene los servicios asociados a una categoría y actualiza el estado de ServicioSeleccionado y ListaServicios.
	 * @param {string} id - ID de la categoría para filtrar los servicios.
	 */
	const getServicios = (id) => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'servicio/',
		})
			.then((response) => {
				// Inicializa una lista vacía para almacenar los servicios filtrados.
				let lista = [];

				// Filtra la respuesta de la solicitud según el ID de la categoría.
				response.data.filter((servicio) => {
					// Verifica si el ID de la categoría del servicio coincide con el ID proporcionado.
					if (servicio.categoria_id.id === id) {
						// Actualiza el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
						setServicioSeleccionado({...ServicioSeleccionado, ...servicio});
						// Agrega el servicio a la lista de servicios filtrados.
						lista.push(servicio);
					}
				});
				// Actualiza el estado de ListaServicios con la lista de servicios filtrados.
				setListaServicios([...lista]);
			})
			.catch((error) => {
				console.error(error);
				setModalErrorCargarServicios(true);
			});
	};

	/**
	 * Selecciona una sede y actualiza el estado de sedeSeleccionada.
	 * @param {string} id - Id de la sede a seleccionar.
	 */
	const seleccionarSede = (id, indice) => {
		const listAux = [...ServiciosPosibles];
		setServiciosPosibles(listAux);
		// Iteramos sobre cada sede en sedes.
		sedes.map((sede, index) => {
			// Verificamos si el id de la sede coincide.
			if (sede.id === id) {
				if (!ServicioSeleccionado.sedes.includes(id)) {
					// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
					ServicioSeleccionado.sedes.push(id);
					setsedeSeleccionada({...sedeSeleccionada, [id]: id});
				} else {
					// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
					ServicioSeleccionado.sedes.splice(ServicioSeleccionado.sedes.indexOf(id), 1);
					delete sedeSeleccionada[id];
				}
			}
		});
	};

	/**
	 * Selecciona una supercategoría y actualiza el estado de SuperCateSeleccionada, así como la lista de categorías filtrada.
	 * @param {string} nombre - Nombre de la supercategoría a seleccionar.
	 */
	const seleccionarSuperCat = (nombre) => {
		// Iteramos sobre cada supercategoría en superCat.
		superCat.map((supercat) => {
			// Verificamos si el nombre de la supercategoría coincide.
			if (supercat.nombre === nombre) {
				// Actualizamos el estado de SuperCateSeleccionada con los atributos de la supercategoría seleccionada.
				setSuperCateSeleccionada({...supercat});

				// Filtramos la lista de categorías para obtener las categorías asociadas a la supercategoría seleccionada.
				const categoriasFiltradas = ListaCategorias.filter((categoria) => {
					// Verificamos si la supercategoría de la categoría coincide con el ID de la supercategoría seleccionada.
					if (categoria.superCategoria === supercat.id) {
						// Actualizamos el estado de CategoriaSeleccionada para borrar cualquier selección previa.
						setCategoriaSelecionada({});
						return categoria;
					}
				});

				// Actualizamos el estado de ListaCategoriasFiltrada con las categorías filtradas.
				setListaCategoriasFiltrada(categoriasFiltradas);
			}
		});
	};

	/**
	 * Selecciona una categoría y actualiza el estado de CategoriaSeleccionada.
	 * @param {string} nombre - Nombre de la categoría a seleccionar.
	 */
	const seleccionarCategoria = (nombre) => {
		// Iteramos sobre cada categoría en la lista de categorías filtrada.
		ListaCategoriasFiltrada.map((categoria) => {
			// Verificamos si el nombre de la categoría coincide.
			if (categoria.nombre === nombre) {
				// Actualizamos el estado de CategoriaSeleccionada con los atributos de la categoría seleccionada.
				setCategoriaSelecionada({...categoria});

				// Obtenemos los servicios asociados a la categoría seleccionada.
				// getServicios(categoria.id);
			}
		});
	};

	useEffect(()=>{
		if(CategoriaSelecionada.id){
			getServicios(CategoriaSelecionada.id)
			setServicioSeleccionado({...ServicioSeleccionado, categoria_id: CategoriaSelecionada.id})
		}
	},[CategoriaSelecionada])

	/**
	 * Selecciona un servicio y actualiza el estado de ServicioSeleccionado.
	 * @param {string} nombre - Nombre del servicio a seleccionar.
	 */
	const seleccionarServicio = (nombre) => {
		// Iteramos sobre cada servicio en la lista de servicios.
		ListaServicios.map((servicio) => {
			// Verificamos si el nombre del servicio coincide.
			if (servicio.nombre === nombre) {
				// Actualizamos el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
				setServicioSeleccionado({...ServicioSeleccionado, ...servicio});
			}
		});
	};

	useEffect(() => {
		getCategorias();
	}, []);

	/**
	 * Cambia el estado de un día en el horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 */
	const changeServicioHorarioDiaEstado = (id, nombre) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Cambiamos el estado del día invirtiendo su valor actual.
				dia.estado = !dia.estado;
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Cambia la hora de inicio o fin de un periodo en el horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 * @param {string} per_id - ID del periodo.
	 * @param {boolean} init_fin - Indica si se va a cambiar la hora de inicio (true) o la hora de fin (false).
	 * @param {Event} event - Evento que contiene el valor de la nueva hora.
	 */
	const cambiarHora = (id, nombre, per_id, init_fin, event) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Recorremos cada periodo en el día.
				dia.periodos.map((periodo) => {
					// Verificamos si el ID del periodo coincide.
					if (per_id === periodo.id) {
						// Actualizamos la hora de inicio o fin del periodo según el valor de init_fin.
						if (init_fin) {
							periodo.hora_inicio = event.target.value;
						} else {
							periodo.hora_fin = event.target.value;
						}
					}
				});
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Añade un nuevo periodo al horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 */
	const anadirPeriodo = (id, nombre) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide.
			if (nombre === dia.nombre) {
				// Generamos un nuevo periodo y lo añadimos al final de los periodos existentes.
				dia.periodos.push({
					id: dia.periodos[dia.periodos.length - 1].id + 1,
					hora_inicio: sumarMinuto(dia.periodos[dia.periodos.length - 1].hora_fin),
					hora_fin: sumarMinuto(
						sumarUnaHora(dia.periodos[dia.periodos.length - 1].hora_fin)
					),
					solapamiento: false,
				});
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Borra un periodo del horario de un servicio seleccionado.
	 * @param {string} id - ID del servicio seleccionado.
	 * @param {string} nombre - Nombre del día en el horario.
	 * @param {string} per_id - ID del periodo a borrar.
	 */
	const borrarPeriodo = (id, nombre, per_id) => {
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let serv = {...ServicioSeleccionado};

		// Recorremos cada día en el horario del servicio.
		serv.horario.map((dia) => {
			// Verificamos si el nombre del día coincide y si tiene más de un periodo.
			if (nombre === dia.nombre && dia.periodos.length > 1) {
				// Eliminamos el último periodo del día usando el método pop().
				dia.periodos.pop();
			}
		});

		// Actualizamos el servicio seleccionado con los cambios realizados.
		setServicioSeleccionado({...serv});
	};

	/**
	 * Verifica si el servicio seleccionado está completo.
	 * @returns {boolean} true si el servicio está completo, de lo contrario false.
	 */
	const servicioCompleto = () => {
		let listadoErrores = [];
		// Copiamos el objeto ServicioSeleccionado usando el operador de propagación (spread operator).
		let objeto = {...ServicioSeleccionado};

		// Verificamos si el objeto es nulo o indefinido.
		if (objeto === null || objeto === undefined) {
			listadoErrores.push('No se ha definido ningún servicio.');
		}

		// Recorremos cada atributo en el objeto.
		for (let atributo in objeto) {
			// Verificamos si el atributo es nulo, indefinido o si su precio mínimo es 0.
			if (
				objeto[atributo] === null ||
				objeto[atributo] === undefined ||
				objeto[atributo].precioMin === 0
			) {
				return false;
			}
		}

		// Verificamos si el precio mínimo es nulo, indefinido o 0.
		if (objeto.precioMin === null || objeto.precioMin === undefined || isNaN(objeto.precioMin)) {
			listadoErrores.push('El precio mínimo no puede estar vacío.');
		}

		// Verificamos si las horas mínimas son 0.
		if (objeto.horasMin === 0 || objeto.horasMin === null || objeto.horasMin === undefined || isNaN(objeto.horasMin)) {
			listadoErrores.push('Debe asignar un rango de tiempo.');
		}

		// Verificamos si la descripción está vacía.
		if (objeto.descripcion === '' || objeto.descripcion === null || objeto.descripcion === undefined) {
			listadoErrores.push('La descripción no puede estar vacía.');
		}

		if (listadoErrores.length > 0) {
			setErroresFormulario(listadoErrores);
			return false;
		}

		// Si todas las verificaciones pasan, el servicio se considera completo.
		return true;
	};
	const enviarCategoriaNueva = () => {
		console.log('Servicio seleccionado',ServicioSeleccionado)
		axios({
			method: 'post',
			url: window.ipdirection + 'categoriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {
				empresa_id: Usuario.prestadorServicios.id,
				categoria_id: ServicioSeleccionado.categoria_id,
			},
		})
			.then((response) => {
				if (ServicioPersonalizado) {
					// Verifica si el nombre personalizado del servicio no está vacío.
					if (ServicioSeleccionado.nombrePersonalizado !== '') {
						// Envia el servicio personalizado utilizando la función enviarServicioPersonalizado().
						enviarServicioPersonalizado();
					} else {
						// Muestra el modal de servicio no completo.
						setModalServicioNoCompleto(true);
					}
				} else {
					// Se comprueba si la categoria ya esta registrada
					enviarServicioNormal();
				}
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error.error);
			});
	};
	/**
	 * Comprueba las categorías de la empresa y realiza las acciones correspondientes.
	 */
	const comprobarCategorias = () => {
		// Realiza una solicitud HTTP GET utilizando Axios.
		axios({
			method: 'get',
			url: window.ipdirection + 'categoriaEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let esta = false;

				// Verifica si la categoría del ServicioSeleccionado está presente en los datos de categorías de la empresa.
				response.data.map((categoria) => {
					if (categoria.categoria_id.id === ServicioSeleccionado.categoria_id) {
						esta = true;
						// Envía el servicio normal si la categoría está presente.
						// Verifica si el servicio es personalizado.
						if (ServicioPersonalizado) {
							// Verifica si el nombre personalizado del servicio no está vacío.
							if (ServicioSeleccionado.nombrePersonalizado !== '') {
								// Envia el servicio personalizado utilizando la función enviarServicioPersonalizado().
								enviarServicioPersonalizado();
							} else {
								// Muestra el modal de servicio no completo.
								setModalServicioNoCompleto(true);
							}
						} else {
							// Se comprueba si la categoria ya esta registrada
							enviarServicioNormal();
						}
					}
				});
				// Si la categoría no está presente, se envía una categoría nueva.
				if (!esta) {
					enviarCategoriaNueva();
				}
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	const enviarPeriodos = (servicio_id_id) => {
		ServicioSeleccionado.horario.forEach((dia) => {
			let nombre = '';
			if (dia.estado) {
				nombre = dia.nombre;
				// Loop through each period in the day
				dia.periodos.forEach((per) => {
					// Create the data object with the period information
					let data = {
						hora_inicio: per.hora_inicio,
						hora_fin: per.hora_fin,
						servicio_empresa: servicio_id_id,
						nombre: nombre,
					};
					// Send a POST request to the server to create the period
					axios({
						method: 'post',
						url: window.ipdirection + 'periodoServicioEmpresa/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						data: data,
					})
						.then((response) => {})
						.catch((error) => {
							console.log(error);
						});
				});
			}
		});
		setModalServicioOk(true);
	};
	const enviarServicioNormal = (servicio_id) => {
		let idServ;

		if (servicio_id === null || servicio_id === undefined) {
			idServ = ServicioSeleccionado.id;
		} else {
			idServ = servicio_id;
		}

		let data = {
			prestadorServicios_id: Usuario.prestadorServicios.id,
			servicio_id: idServ,
			precioMin: ServicioSeleccionado.precioMin,
			horasMin: ServicioSeleccionado.horasMin,
			descripcion: ServicioSeleccionado.descripcion,
			shareCare: ServicioSeleccionado.shareCare,
			domicilio: ServicioSeleccionado.domicilio,
			sedes: ServicioSeleccionado.sedes,
			idsSedes: sedeSeleccionada,
		};

		axios({
			method: 'post',
			url: window.ipdirection + 'servicioEmpresa/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				let servicio_id_id = response.data.servicio_Empresa.id;
				enviarPeriodos(servicio_id_id);
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	const enviarServicioPersonalizado = () => {
		const data = {
			nombre: ServicioSeleccionado.nombrePersonalizado,
			categoria_id: ServicioSeleccionado.categoria_id,
		};
		axios({
			method: 'post',
			url: window.ipdirection + 'servicio/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				const servicio_id = response.data.id;
				enviarServicioNormal(servicio_id);
			})
			.catch((error) => {
				setModalErrorConsulta(true);
				console.log(error);
			});
	};

	/**
	 * Envia el servicio si está completo y cumple con todas las condiciones.
	 */
	const enviarServicio = () => {
		// Verifica si el servicio está completo utilizando la función servicioCompleto().
		if (servicioCompleto()) {
			comprobarCategorias();
		} else {
			// Muestra el modal de servicio no completo.
			setModalServicioNoCompleto(true);
		}
	};

	return (
		<>
			<div className='Body-CatServañadir'>
				<div className='content-Body-CatServañadir'>
					<div className='title-CatServActivos title-1'>
						<h2>Añadir servicio</h2>
					</div>
					<div className='separador' />
					<div className='lista-inputs-añadir-servicio'>
						<div className='input-añadir-servicio'>
							<div className='label-formulario-registro'>
								<div>
									<b>Super-Categoria:</b>
								</div>
								<div>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='10'
										height='10'
										fill='currentColor'
										class='bi bi-asterisk'
										viewBox='0 0 16 16'
									>
										<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
									</svg>
								</div>
							</div>
							<Dropdown
								className='dropDown-añaidrServicio-empresa '
								options={superCat.map((supercat) => {
									return supercat.nombre;
								})}
								onChange={(e) => seleccionarSuperCat(e.value)}
								value={SuperCateSeleccionada.nombre}
								placeholder={'-- Selecionar --'}
							/>
						</div>

						{SuperCateSeleccionada.id !== undefined && (
							<div className='input-añadir-servicio'>
								<div className='label-formulario-registro'>
									<div>
										<b>Categoria:</b>
									</div>
									<div>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='10'
											height='10'
											fill='currentColor'
											class='bi bi-asterisk'
											viewBox='0 0 16 16'
										>
											<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
										</svg>
									</div>
								</div>
								<Dropdown
									className='dropDown-añaidrServicio-empresa '
									options={ListaCategoriasFiltrada.map((categoria) => {
										return categoria.nombre;
									})}
									onChange={(e) => seleccionarCategoria(e.value)}
									value={CategoriaSelecionada.nombre}
									placeholder={'-- Selecionar --'}
								/>
							</div>
						)}

						{CategoriaSelecionada.id !== undefined && (
							<>
								<div className='input-añadir-servicio_switch'>
									<div className='label-formulario-registro'>
										<div>
											<b>Servicio Personalizado:</b>
										</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									<Switch
										onChange={() =>
											setServicioPersonalizado(!ServicioPersonalizado)
										}
										checked={ServicioPersonalizado}
										onColor='#23C290'
										uncheckedIcon={false}
									/>
								</div>
								{!ServicioPersonalizado ? (
									<div className='input-añadir-servicio'>
										<div className='label-formulario-registro'>
											<div>
												<b>Servicio:</b>
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<Dropdown
											className='dropDown-añaidrServicio-empresa '
											options={ListaServicios.map((servicio) => {
												return servicio.nombre;
											})}
											onChange={(e) => seleccionarServicio(e.value)}
											value={ServicioSeleccionado.nombre}
											placeholder={'-- Selecionar --'}
										/>
									</div>
								) : (
									<div className='input-añadir-servicio'>
										<div className='label-formulario-registro'>
											<div>
												<b>Nombre del servicio:</b>
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<input
											className='text'
											class='inputTextUsuario'
											value={ServicioSeleccionado.nombrePersonalizado}
											onChange={(e) =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													nombrePersonalizado: e.target.value,
												})
											}
										/>
									</div>
								)}
								<div className='datos-servicio-nuevo'>
									<div className='dato-servicio-nuevo'>
										<div className='label-formulario-registro'>
											<div>
												<b>Domicilio :</b>
											</div>
										</div>
										<Switch
											onChange={() =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													domicilio: !ServicioSeleccionado.domicilio,
												})
											}
											checked={ServicioSeleccionado.domicilio}
											onColor='#23C290'
											uncheckedIcon={false}
										/>
									</div>
									{/* <div className='dato-servicio-nuevo'>
										{ServicioSeleccionado.domicilio ? (
											<>
												<div className='label-formulario-registro'>
													<div>
														<b>ShareCare :</b>
													</div>
												</div>
												<Switch
													onChange={() =>
														setServicioSeleccionado({
															...ServicioSeleccionado,
															shareCare:
																!ServicioSeleccionado.shareCare,
														})
													}
													checked={ServicioSeleccionado.shareCare}
													onColor='#23C290'
													uncheckedIcon={false}
												/>
											</>
										) : (
											<>
												<div />
												<div />
											</>
										)}
									</div> */}
								</div>
								<div className='datos-servicio-nuevo'>
									<div className='dato-servicio-nuevo'>
										<div className='label-formulario-registro'>
											<div>
												<b>Duración (min):</b>
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<div className='input_dato-servicio-nuevo'>
											<Dropdown
												className='dropDown-añaidrServicio-empresa '
												options={['10', '30', '50', '60', '120']}
												onChange={(e) =>
													setServicioSeleccionado({
														...ServicioSeleccionado,
														horasMin: parseInt(e.value),
													})
												}
												value={ServicioSeleccionado.horasMin.toString()}
											/>
										</div>
									</div>
									<div className='dato-servicio-nuevo'>
										<div className='label-formulario-registro'>
											<div>
												<b>Precio (€):</b>
											</div>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='10'
													height='10'
													fill='currentColor'
													class='bi bi-asterisk'
													viewBox='0 0 16 16'
												>
													<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
												</svg>
											</div>
										</div>
										<div className='input_dato-servicio-nuevo'>
											<input
												type='number'
												value={ServicioSeleccionado.precioMin}
												step='0.05'
												onChange={(e) => {
													setServicioSeleccionado({
														...ServicioSeleccionado,
														precioMin: parseFloat(e.target.value),
													});
												}}
											/>
										</div>
									</div>
								</div>

								<div className='input-añadir-servicio'>
									<div className='label-formulario-registro'>
										<div>
											<b>Sedes en las que está disponible el servicio:</b>
										</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									{sedes.map((sede, index) => (
										<div className='formCategorias'>
											<div className='centradorLeft'>
												{sede['nombreSede']}
											</div>
											<Checkbox
												sx={{
													color: '23C290',
													'&.Mui-checked': {color: '#23C290'},
												}}
												checked={ServicioSeleccionado.sedes.includes(
													sede.id
												)}
												onChange={(e) => seleccionarSede(sede.id, index)}
											/>
										</div>
									))}
								</div>

								<div className='input-añadir-servicio'>
									<div className='label-formulario-registro'>
										<div>
											<b>Descripción del servicio:</b>
										</div>
										<div>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='10'
												height='10'
												fill='currentColor'
												class='bi bi-asterisk'
												viewBox='0 0 16 16'
											>
												<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
											</svg>
										</div>
									</div>
									<div>
										<TextArea
											Id='textArea'
											placeholder={'Descripción de la empresa'}
											name={'descripcionEmpresa'}
											value={ServicioSeleccionado.descripcion}
											onChange={(e) =>
												setServicioSeleccionado({
													...ServicioSeleccionado,
													descripcion: e.target.value,
												})
											}
											fullWidth={true}
										/>
									</div>
								</div>
								<div className='centrador'>
									<div
										className='personalizar-horario-anadir-servicio_CategoriasEmpresa'
										onClick={() => setModalPeriodo(true)}
									>
										<div className='centradorRight'>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='20'
												height='20:wall'
												fill='currentColor'
												class='bi bi-calendar2-week-fill'
												viewBox='0 0 16 16'
											>
												<path d='M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM8.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM3 10.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z' />
											</svg>
										</div>
										<div className='centradorLeft'>Seleccionar Horario</div>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
				<div
					className='centradorRight'
					onClick={enviarServicio}
				>
					<div className='button'>
						<b>Enviar</b>
					</div>
				</div>
			</div>

			<ModalPerido
				ModalPer={ModalPeriodo}
				setModalPer={setModalPeriodo}
				servicio={ServicioSeleccionado}
				changeServicioHorarioDiaEstado={changeServicioHorarioDiaEstado}
				cambiarHora={cambiarHora}
				anadirPeriodo={anadirPeriodo}
				borrarPeriodo={borrarPeriodo}
			/>

			<Modal
				centered={true}
				isOpen={ModalServicioNoCompleto}
			>
				<ModalHeader>
					<div className='titulo-modal'>Ups... !</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{
							ErroresFormulario.map((error, index) => (
								<li key={index}>{error}</li>
							))
						}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalServicioNoCompleto(false)}
						>
							<b>Cerrar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalErrorConsulta}
			>
				<ModalHeader>
					<div className='titulo-modal'>Ups... !</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al enviar los datos, vuelvalo a intentar mas tarde.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalErrorConsulta(false)}
						>
							<b>Cerrar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalServicioOk}
			>
				<ModalHeader>
					<div className='titulo-modal'>¡Enorabuena!</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Su servicio ha sido registrado correctamente
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalServicioOk(false)}
						>
							<b>Cerrar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalErrorCargarCategorias}
			>
				<ModalHeader>
					<div className='titulo-modal'>Ups... !</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al cargar la lista de categorias.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalErrorCargarCategorias(false)}
						>
							<b>Cerrar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalErrorCargarServicios}
			>
				<ModalHeader>
					<div className='titulo-modal'>Ups... !</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Parece que hubo un error al cargar la lista de servicios.
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setModalErrorCargarServicios(false)}
						>
							<b>Cerrar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
